import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_tax_filing_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tax_txn_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  filing_status: fromDatatype.StatusDataFieldInterface;
  amount_debit: fromDatatype.NumericDatatypeInterface;
  amount_credit: fromDatatype.NumericDatatypeInterface;
  doc_event_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_tax_filing_link_RowClass
  implements bl_fi_tax_filing_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  filing_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tax_txn_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  reference_num: fromDatatype.VarcharDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  filing_status: fromDatatype.StatusDataFieldInterface;
  amount_debit: fromDatatype.NumericDatatypeInterface;
  amount_credit: fromDatatype.NumericDatatypeInterface;
  doc_event_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
